import { lazy } from "react";
import { Navigate } from "react-router-dom";
import HomePage from "../pages/HomePage/HomePage.js";
import UsersPage from "../pages/UsersPage/UsersPage.js";
import DoctorsPage from "../pages/DoctorsPage/DoctorsPage.js";
import TypesPage from "../pages/TypesPage/TypesPage.js";
import PatientsPage from "../pages/PatientsPage/PatientsPage.js";
import ProvidersPage from "../pages/ProvidersPage/ProvidersPage.js";
import UserRecord from "../pages/Records/UserRecord/UserRecord.js";
import DoctorRecord from "../pages/Records/DoctorRecord/DoctorRecord.js";
import LoginPage from "../pages/LoginPage/LoginPage.js";
import TypeRecord from "../pages/Records/TypeRecord/TypeRecord.js";
import PatientRecord from "../pages/Records/PatientRecord/PatientRecord.js";
import ProviderRecord from "../pages/Records/ProviderRecord/ProviderRecord.js";
import InflowPage from "../pages/InflowPage/InflowPage.js";
import InflowRecord from "../pages/Records/InflowRecord/InflowRecord.js";
import OutflowPage from "../pages/OutflowPage/OutflowPage.js";
import OutflowRecord from "../pages/Records/OutflowRecord/OutflowRecord.js";
import ControlPage from "../pages/ControlPage/ControlPage.js";
import GraphicPage from "../pages/GraphicPage/GraphicPage.js";

/****Layouts*****/
const FullLayout = lazy(() => import("../layouts/FullLayout/FullLayout.js"));
/****End Layouts*****/

/*****Routes******/

const ThemeRoutes = [
  { path: "/login", element: <LoginPage /> },

  {
    path: "/",
    element: <FullLayout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/users", element: <UsersPage /> },
      { path: "/users/create", element: <UserRecord /> },
      { path: "/doctors", element: <DoctorsPage /> },
      { path: "/doctors/create", element: <DoctorRecord /> },
      { path: "/types", element: <TypesPage /> },
      { path: "/types/create", element: <TypeRecord /> },
      { path: "/patients", element: <PatientsPage /> },
      { path: "/patients/create", element: <PatientRecord /> },
      { path: "/providers", element: <ProvidersPage /> },
      { path: "/providers/create", element: <ProviderRecord /> },
      { path: "/inflows", element: <InflowPage /> },
      { path: "/inflows/create", element: <InflowRecord /> },
      { path: "/outflows", element: <OutflowPage /> },
      { path: "/outflows/create", element: <OutflowRecord /> },
      { path: "/control", element: <ControlPage /> },
      { path: "/graphic", element: <GraphicPage /> },
    ],
  },
];

export default ThemeRoutes;
